import React , {useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PostCategoryForm } from '@app/components/forms/PostCategoryForm/PostCategoryForm'; 

import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { useParams } from 'react-router-dom';
import { showPostCategory } from '@app/api/postCategories.api';

interface RouteParams {
  id: string;
  [key: string]: string | undefined;
}

const ViewPostCategoryPage: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams<RouteParams>();
  // const [PostCategoryName, setPostCategoryName] = useState<string>('');
  // const [loading, setLoading] = useState<boolean>(true);

  // useEffect(() => {
  //   // Fetch category data when component mounts
  //   if (id) {
  //     showPostCategory(parseInt(id)).then((res: any) => {
  //       setPostCategoryName(res?.postCategory?.name || '');
  //       setLoading(false);
  //     });
  //   }
  // }, [id]);

  // if (loading) {
  //   return <div>Loading...</div>; 
  // }

  return (
    <>
        <PageTitle>{"JRDC-Admin"}</PageTitle>
        {/* <PageTitle>{t('View-Post-Category')}</PageTitle> */}
        <PostCategoryForm type={"view"} id={id} editable={false}/>
    </>
  );
};

export default ViewPostCategoryPage;
